import type { DefaultDataLayerTrackingEvent } from 'autogen/swagger/all';
import { useIsDesktop, useIsMobile } from 'hooks/responsive';
import usePageContext from 'hooks/user/usePageContext';
import useUserContext from 'hooks/user/useUserContext';
import { useEffect } from 'react';

type NullableDataLayerTrackingKeys =
    | 'appHeader'
    | 'brandId'
    | 'brandName'
    | 'categoryId'
    | 'categoryName'
    | 'categoryStock';

type DefaultDataLayerTracking = Omit<DefaultDataLayerTrackingEvent, NullableDataLayerTrackingKeys> & {
    [Key in NullableDataLayerTrackingKeys]?: DefaultDataLayerTrackingEvent[Key];
};

const trackingType = 'DefaultDataLayerTrackingEvent';
export default function useDefaultDataLayerTrackingEvent(props: Partial<DefaultDataLayerTracking> | undefined) {
    const pageType = props?.pageType || usePageContext().pageType;
    const isGa4Debug = props?.isGa4Debug || useUserContext().isGa4Debug;
    const isDesktop = props?.isDesktop || useIsDesktop();
    const isMobile = props?.isMobile || useIsMobile();

    return () => {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        if (window.dataLayer.find((item) => item.$type === trackingType)) {
            return;
        }

        const defaultDataLayerTrackingEvent: DefaultDataLayerTracking = {
            pageType,
            isGa4Debug,
            isDesktop,
            isMobile,
            $type: trackingType
        };

        window.dataLayer.push(defaultDataLayerTrackingEvent);
    };
}
